import en from './en.json'
import it from './it.json'

export const adminTranslations = {
	en,
	it
} as const
